export const KREEDZ_URL = 'https://kreedz.com';
export const KREEDZ_LINK = { label: 'Kreedz.com', path: KREEDZ_URL };

const KREEDZ_HOSTS = new Set(['kreedz.com', 'www.kreedz.com']);

export const isValidFooterLink = (link) =>
  Boolean(
    link &&
    typeof link.label === 'string' &&
    link.label.trim() &&
    typeof link.path === 'string' &&
    link.path.trim()
  );

const isKreedzRootUrl = (value) => {
  if (typeof value !== 'string') return false;

  const raw = value.trim();
  if (!raw || !/^(?:https?:\/\/|\/\/)/i.test(raw)) return false;

  try {
    const parsed = new URL(raw, KREEDZ_URL);
    const pathname = decodeURIComponent(parsed.pathname).replace(/\/+$/, '') || '/';
    return (
      (parsed.protocol === 'http:' || parsed.protocol === 'https:') &&
      KREEDZ_HOSTS.has(parsed.hostname.toLowerCase()) &&
      !parsed.username &&
      !parsed.password &&
      !parsed.port &&
      pathname === '/'
    );
  } catch {
    return false;
  }
};

/** Remove configured copies so the required link can be rendered exactly once. */
export const removeKreedzLinks = (columns) =>
  (Array.isArray(columns) ? columns : []).map((column) => ({
    ...column,
    links: Array.isArray(column?.links)
      ? column.links.filter((link) => !isKreedzRootUrl(link?.path))
      : [],
  }));

/**
 * Add the required Kreedz destination to the contact/about column. This is
 * intentionally a render-time invariant rather than a remotely editable
 * site-config value.
 */
export const appendPermanentKreedzLink = (columns) => {
  const cleaned = removeKreedzLinks(columns)
    .filter((column) => column && typeof column.heading === 'string' && column.heading.trim())
    .map((column) => ({
      ...column,
      links: (Array.isArray(column.links) ? column.links : []).filter(isValidFooterLink),
    }))
    .filter((column) => column.links.length > 0);

  if (cleaned.length === 0) {
    return [{ heading: 'About', links: [{ ...KREEDZ_LINK }] }];
  }

  const contactIndex = cleaned.findIndex(
    (column) =>
      /contact/i.test(column.heading) ||
      column.links.some((link) => /contact/i.test(link.label || ''))
  );
  const destinationIndex = contactIndex >= 0 ? contactIndex : cleaned.length - 1;

  return cleaned.map((column, index) =>
    index === destinationIndex
      ? { ...column, links: [...column.links, { ...KREEDZ_LINK }] }
      : column
  );
};
